export const GROUP_KEY_PREFIX = '__group__:';

export const CATEGORY_COLORS = { blue: '#7AAFF9', green: '#76E570', orange: '#FFBD7C', yellow: '#FFDC7C', red: '#F77D79', purple: '#BC70E5' };
